import React, { useContext, useEffect, useState } from "react";
import { downloadDTP, getAffaires, getSchema } from "../../api/geoprod";
import axiosInstance from "../../utils/axios";
import { useLoader } from "../../context/LoaderContext";
import {
  Button,
  Card,
  Dropdown,
  notification,
  Space,
  Table,
  Tooltip,
} from "antd";
import { useTranslation } from "react-i18next";
import CommentModal from "../Etablissements/CreateEpf/Modals/CommentModal";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { DownOutlined, InfoCircleOutlined } from "@ant-design/icons";
import i18next from "i18next";
import classes from "../Etablissements/Etablissements.module.css";
import GlobalContext from "../../context/GlobalContext";

const Homologations = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [commentaire, setCommentaire] = useState([]);
  const {setGlobalData}=useContext(GlobalContext);
  const idAffaire = new URLSearchParams(window.location.search).get("id");
  const { setIsLoading } = useLoader();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const columns = [
    {
      title: t("Spécialité"),
      key: "training_type_data_specialty",
      render: (_, record) => {
        const text = record?.training_type_data_specialty || t("Non renseigné");
        return (
          <Tooltip title={text}>
            <span
              style={{
                display: "inline-block",
                maxWidth: 150,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {text}
            </span>
          </Tooltip>
        );
      },
    },
    {
      title: t("Diplôme"),
      key: "training_type_data_diploma",
      render: (_, record) => {
        const text = record?.training_type_data_diploma || t("Non renseigné");
        return (
          <Tooltip title={text}>
            <span
              style={{
                display: "inline-block",
                maxWidth: 150,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {text}
            </span>
          </Tooltip>
        );
      },
    },
    {
      title: t("Date de début de l’homologation"),
      key: "Date de début de l’homologation",
      render: (_, record) =>
        record?.date_debut_homologation
          ? dayjs(record?.date_debut_homologation).format("DD/MM/YYYY HH:MM:ss")
          : t("Non renseigné"),
    },
    {
      title: t("Date de fin de l’homologation"),
      key: "Date de fin de l’homologation",
      render: (_, record) =>
        record?.date_fin_homologation
          ? dayjs(record?.date_fin_homologation).format("DD/MM/YYYY HH:MM:ss")
          : t("Non renseigné"),
    },

    {
      title: t("Numéro d'enregistrement"),
      key: "Numéro d'enregistrement",
      render: (_, record) =>
        record?.registration_number
          ? record?.registration_number
          : t("Non renseigné"),
    },
    {
      title: t("Dénomination"),
      key: "dénomination",
      render: (_, record) =>
        record?.establishment_data_commercial_name ||
        record?.establishment_data_official_name ||
        record?.legal_entity_official_name,
    },

    {
      title: t("Actions"),
      key: "Actions",
      render: (_, record) => (
        <Space>
          <Dropdown
            menu={{
              items: [
                {
                  label: (
                    <Button
                      size="small"
                      block
                      onClick={async () => {
                        sessionStorage.setItem("consulter", true);
                        setIsLoading(true);

                        const res = await getSchema(record.affaire_id);
                        if (res?.response) {
                          setIsLoading(false);
                          const { data } = res?.response;
                          sessionStorage.setItem(
                            "globalData",
                            JSON.stringify(data)
                          );
                          setGlobalData(data);
                          navigate("/formations/newHomologation", {
                            state: {
                              id_homologation: record?.affaire_id,
                            },
                          });
                          sessionStorage.setItem(
                            "id_homologation",
                            record?.affaire_id
                          );
                          //   await setSurveyJson(form);
                          //   await setSurveyData(data);
                          //   setSurveyJsonValidationProvisoire(
                          //     res?.response?.form_valid
                          //   );
                        }
                        setIsLoading(false);
                      }}
                    >
                      {t("Consulter l'homologation")}
                    </Button>
                  ),
                },
                {
                  label: (
                    <Button
                      size="small"
                      block
                      onClick={async () => {
                        setIsLoading(true);
                        sessionStorage.setItem("consulter", false);

                        axiosInstance
                          .get(
                            `${
                              import.meta.env.VITE_APP_GEOPROD_API
                            }/check_homologation_by_id_formation/${
                              record?.id_formation_check
                            }`,
                            {
                              headers: {
                                Idsession: JSON.parse(
                                  localStorage.getItem("-x-token-user")
                                )?.Acces_Token,
                              },
                            }
                          )
                          .then(async (resultat) => {
                            if (
                              !resultat?.data?.message?.renouvellement
                                ?.renouvellement
                            ) {
                              notification.info({
                                message: t("info"),
                                description: t(
                                  resultat?.data?.message?.renouvellement
                                    ?.message
                                ),
                                duration: 0,
                              });
                            } else {
                              const res = await getSchema(record.affaire_id);
                              if (res?.response) {
                                setIsLoading(false);
                                const { data } = res?.response;
                                sessionStorage.setItem(
                                  "globalData",
                                  JSON.stringify(data)
                                );
                                navigate("/formations/newHomologation", {
                                  state: {
                                    id_affaire_parent: record?.affaire_id,
                                    selectedType: "renouvellement",
                                    epf_data: {
                                      registration_number:
                                        record.registration_number,
                                    },
                                  },
                                });
                                sessionStorage.setItem(
                                  "id_homologation",
                                  record?.affaire_id
                                );
                              }
                            }
                          });
                        setIsLoading(false);
                      }}
                    >
                      {t("Renouveller l'homologation")}
                    </Button>
                  ),
                },
                {
                  label: (
                    <Button
                      size="small"
                      block
                      onClick={() => handleGetComment(record?.affaire_id)}
                    >
                      {t("Commentaires")}
                    </Button>
                  ),
                },
                {
                  label: (
                    <Button
                      size="small"
                      block
                      onClick={() => handleDownloadDTP(record?.affaire_id)}
                    >
                      {t("Document DTP")}
                    </Button>
                  ),
                },
              ],
            }}
            trigger={["click"]}
          >
            <span style={{ cursor: "pointer" }}>
              <Space>
                {t("Liste")}
                <DownOutlined />
              </Space>
            </span>
          </Dropdown>
        </Space>
      ),
    },
  ];

  const handleGetComment = (id_affaire) => {
    setIsLoading(true);
    axiosInstance
      .get(
        `${
          import.meta.env.VITE_APP_GEOPROD_API
        }/commentaire/get_investisseur_commentaires?entity=A&id_entity=${id_affaire}`,
        {
          headers: {
            Idsession: JSON.parse(localStorage.getItem("-x-token-user"))
              ?.Acces_Token,
          },
        }
      )
      .then((res) => {
        setIsLoading(false);
        if (res?.data?.info?.length > 0) {
          setCommentaire(res?.data?.info);
        } else {
          notification.warning({
            message: t(
              "Vous ne disposez pas de commentaire pour cette demande !"
            ),
            duration: 0,
          });
        }
      })
      .catch(() => {
        setIsLoading(false);
      });
  };

  const handleDownloadDTP = async (idAff) => {
    try {
      setIsLoading(true);
      const response = await downloadDTP(idAff);

      if (response) {
        setIsLoading(false);

        window.open(response?.url, "_blank");
      }
    } catch {
      setIsLoading(false);

      notification.error({
        message: t("Erreur"),
        description: "Erreur lors de génération du document DTP",
      });
    }
  };
  useEffect(() => {
    async function fetchData() {
      try {
        const data = await getAffaires({
          id_user: JSON.parse(localStorage.getItem("-x-token-user")).id_user,
          id_entreprise: JSON.parse(localStorage.getItem("-x-token-user")).user
            .entreprise_id,
          filters: {
            contrat: [],
            status: [
              import.meta.env
                .VITE_APP_ID_STATUS_VALIDEE_CREATION_SESSION_FORMATION_NON_HOMOLOGUEE_ET_CONINUE,
              import.meta.env.VITE_APP_ID_STATUS_HOMOLOGATION_CONFIRMEE,
            ],
            excludedStatus: [],
          },
        });

        setData(data?.aaData);
        setLoading(false);
      } catch (error) {}
    }

    fetchData();

    if (idAffaire) {
      handleGetComment(idAffaire);
    }
  }, []);
  return (
    <div>
      <CommentModal commentaire={commentaire} setCommentaire={setCommentaire} />
      <Card
        className={classes.listeCard}
        bordered={false}
        title={
          <div
            style={{
              textAlign: i18next?.language === "fr" ? "left" : "right",
            }}
          >
            {t("Liste de mes diplômes homologués")}
          </div>
        }
      >
        <Table
          locale={{ emptyText: t("Aucune donnée") }}
          loading={loading}
          columns={columns}
          dataSource={data}
          className="ant-border-space"
          style={{ overflowX: "auto" }}
          pagination={false}
        />
      </Card>
    </div>
  );
};

export default Homologations;
